<spinner *ngIf="loading"></spinner>

<form [hidden]="loading">
    <div>
        @for (question of questions; track question; let index = $index) {
            <form-field [orderNumber]="index + 1" [question]="question" [disabled]="disabled" [questions]="questions" [(parentFormGroup)]="formGroup" [defaultValue]="question.answer"></form-field>
        }
    </div>
</form>
